import request from '@/utils/requestYS'

// 民用用户画像->单用户列表
export function getArumPortrayalList(params) {
  return request({
    url: '/userPortrayal/arumPortrayalList',
    method: 'post',
    data: params
  })
}

// 非民用户画像->单用户列表
export function brumPortrayalList(params) {
  return request({
    url: '/userPortrayal/brumPortrayalList',
    method: 'post',
    data: params
  })
}
// 民用非民群用户列表
export function getArumGrouplList(params) {
  return request({
    url: '/userPortrayal/arumGrouplList',
    method: 'post',
    data: params
  })
}

// 民用单用户画像基本信息
export function arumPortrayalOne(params) {
  return request({
    url: '/userPortrayal/arumPortrayalOne',
    method: 'get',
    params
  })
}

// 非民单用户画像基本信息
export function brumPortrayalOne(params) {
  return request({
    url: '/userPortrayal/brumPortrayalOne',
    method: 'get',
    params
  })
}

// 民用非民群画像基本信息
export function groupPortrayalOne(params) {
  return request({
    url: '/userPortrayal/groupPortrayalOne',
    method: 'get',
    params
  })
}

// 根据标签分类查询用户标签接口(单用户画像标签选择用的接口，标签分类有接口)
export function selectLabel(params) {
  return request({
    url: '/userPortrayal/selectLabel',
    method: 'get',
    params
  })
}

// 标签选择(新增修改标签)
export function choiceLable(params) {
  return request({
    url: '/userPortrayal/choiceLable',
    method: 'post',
    data: params
  })
}
// 雷达属性
export function radarAttribute(params) {
  return request({
    url: '/userPortrayal/radarAttribute',
    method: 'get',
    params
  })
}
// 单用户画像异常列表
export function abnormalList(params) {
  return request({
    url: '/userPortrayal/abnormalList',
    method: 'get',
    params
  })
}
// 涛哥-civil_board接口(民用单用户查询)
export function arumGasAnalysis(params) {
  return request({
    url: '/userPortrayal/arumGasAnalysis',
    method: 'get',
    params
  })
}
// 民用群用户查询
export function groupGasAnalysis(params) {
  return request({
    url: '/userPortrayal/groupGasAnalysis',
    method: 'get',
    params
  })
}
// 涛哥-gf_board接口(非民单用户查询)
export function brumGasAnalysis(params) {
  return request({
    url: '/userPortrayal/brumGasAnalysis',
    method: 'get',
    params
  })
}

// 异常解除
export function updateAbnormal(params) {
  return request({
    url: '/userPortrayal/updateAbnormal',
    method: 'post',
    data: params
  })
}
// 异常批量解除
export function updateBatchAbnormal(params) {
  return request({
    url: '/userPortrayal/updateBatchAbnormal',
    method: 'post',
    data: params
  })
}
